import React, { Component } from "react";
import { DatePicker } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SearchSelect from "../../common/SearchSelect";
import sortObject from "../../../functions/sort-object";
import { fetchMerchandisers } from "../../../actions/employeeActions";
import { fetchMerchandiserInvoicingJobs } from "../../../api/menu/invoicing/actions";

class ReportHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            merchandisersOptions: [],
            jobOptions: this.props.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
            })),
        };

        if (!this.props.isChargeApproval) {
            this.props.fetchMerchandisers();
            this.props.fetchMerchandiserInvoicingJobs();
        }
    }

    componentWillUnmount() {
        this.props.fetchMerchandisers(true);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isChargeApproval) {
            return;
        }
        const newState = {};

        newState.merchandisersOptions = [
            { value: null, label: "All Merchandisers" },
            { value: -1, label: "All Manual" },
            { value: -2, label: "All CIRS" }
        ];
        sortObject(
            nextProps.merchandisers,
            Object.keys(nextProps.merchandisers)
                .map((value) => parseInt(value, 10)),
            "lastName",
            true
        )
            .forEach(index => {
                newState.merchandisersOptions.push({
                    value: nextProps.merchandisers[index].id,
                    label: nextProps.merchandisers[index].name
                });
            });

        newState.jobOptions = nextProps.jobs.map(value => ({
            label: `${value.jobNumber} - ${value.description}`,
            value: value.id,
        }));

        if (Object.keys(newState).length) {
            this.setState(newState);
        }
    }

    render() {
        const {
            filters,
            handleSelect,
            isChargeApproval
        } = this.props;
        const {
            merchandisersOptions,
            jobOptions
        } = this.state;

        return (
            <div className="position-relative">
                <div className="row pt-1 pb-3">
                    {
                        isChargeApproval ?
                            null :
                            <div className="col-3">
                                <div className="form-group mb-0">
                                    <label className="d-block mb-0 font-weight-bold form-label">
                                        Merchandiser
                                    </label>
                                    <SearchSelect
                                        className="custom-react-select"
                                        isLoading={false}
                                        isClearable={true}
                                        isSearchable={true}
                                        options={merchandisersOptions}
                                        value={filters.merchandiserId}
                                        onChange={(option) => handleSelect("merchandiserId", option)}
                                    />
                                </div>
                                <label className="d-block mb-0 font-weight-bold form-label">
                                    Job
                                </label>
                                <SearchSelect
                                    className="custom-react-select"
                                    isLoading={false}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={jobOptions}
                                    value={filters.jobId}
                                    onChange={(option) => handleSelect("jobId", option)}
                                />
                            </div>
                    }
                    <div className="col-3">
                        <div className="form-group mb-0">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                From Date
                            </label>
                            <DatePicker
                                value={filters.fromDate}
                                format={this.dateFormat}
                                onChange={date => handleSelect("fromDate", date)}
                                className="d-block"
                            />
                        </div>
                        <div className="form-group mb-0">
                            <label className="d-block mb-0 font-weight-bold form-label">
                                To Date
                            </label>
                            <DatePicker
                                value={filters.toDate}
                                format={this.dateFormat}
                                onChange={date => handleSelect("toDate", date)}
                                className="d-block"
                            />
                        </div>
                    </div>
                    {
                        isChargeApproval ?
                            null :
                            <div className="col-3">
                                <div className="custom-control custom-checkbox mb-4">
                                    <input
                                        id="isHistory"
                                        type="checkbox"
                                        checked={filters.isHistory}
                                        className="custom-control-input"
                                        onChange={() =>
                                            handleSelect("isHistory", !filters.isHistory)}
                                    />
                                    <label
                                        className="custom-control-label"
                                        htmlFor="isHistory"
                                    >
                                        Include History
                                    </label>
                                </div>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

ReportHeader.propTypes = {
    handleSelect: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isChargeApproval: PropTypes.bool
};

const mapStateToProps = state => ({
    merchandisers: state.employee.merchandisers,
    jobs: state.invoicing.jobs,
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandisers: bindActionCreators(fetchMerchandisers, dispatch),
    fetchMerchandiserInvoicingJobs: bindActionCreators(fetchMerchandiserInvoicingJobs, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ReportHeader);
